import { useState } from "react";

import Input from "../../ui/input/Input";
import Button from "../../ui/button/Button";
import Alert from "../../ui/alert/Alert";

import "./MfaSetupForm.css";

export default function MfaSetupForm({
  qrCode,
  manualCode,
  onSubmit,
  isLoading,
  error,
}) {
  const [code, setCode] = useState("");

  const cleanCode = code.replace(/\D/g, "");

  const canSubmit = cleanCode.length === 6 && !isLoading;

  const handleChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 6);

    setCode(value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!canSubmit) return;

    onSubmit(cleanCode);
  };

  return (
    <form className="mfa-setup-form" onSubmit={handleSubmit}>
      <Alert type="info">
        Scan de QR-code met je authenticator-app en vul daarna de 6-cijferige
        code in.
      </Alert>

      {error && <Alert type="error">{error}</Alert>}

      {qrCode && (
        <div className="mfa-setup-form__qr-wrap">
          <img className="mfa-setup-form__qr" src={qrCode} alt="MFA QR" />
        </div>
      )}

      {manualCode && (
        <div className="mfa-setup-form__manual-code">
          <span>Manuele code</span>

          <code>{manualCode}</code>
        </div>
      )}

      <Input
        id="mfaCode"
        label="MFA-code"
        value={code}
        onChange={handleChange}
        placeholder="123456"
        inputMode="numeric"
        maxLength={6}
        autoComplete="one-time-code"
        disabled={isLoading}
      />

      <Button type="submit" disabled={!canSubmit}>
        {isLoading ? "Controleren..." : "Account activeren"}
      </Button>
    </form>
  );
}
